import {TRANSLATION_NL} from 'src/environments/ett/translations/nl';
import {TRANSLATION_DE} from 'src/environments/ett/translations/de';
import {TRANSLATION_EN} from 'src/environments/ett/translations/en';
import {TRANSLATION_TR} from 'src/environments/ett/translations/tr';
import {TRANSLATION_PL} from 'src/environments/ett/translations/pl';
import {TRANSLATION_RO} from 'src/environments/ett/translations/ro';
import {TRANSLATION_PT} from 'src/environments/ett/translations/pt';

export const environment = {
    production: true,
    id: 'nl.ett.wave.acc',
    name: 'Iedereen veilig thuis',
    version: '4.8.0',
    author: {
        name: 'Iedereen veilig thuis',
        email: 'info@ett-wave.nl',
        website: 'https://www.recognize.nl/',
    },
    deprecation: {
        domains: [],
        date: '2099-09-01T00:00:00',
    },
    host: 'vwwave',
    storage: '__wave',
    initialTheme: '',
    color: {
        primary: '#32659C',
        statusBar: {
            default: '#336699',
            overlay: '#14293D',
        },
    },
    supportedLanguages: [
        {
            value: 'nl',
            label: 'Nederlands',
            translationFile: TRANSLATION_NL,
        },
        {
            value: 'de',
            label: 'Deutsch',
            translationFile: TRANSLATION_DE,
        },
        {
            value: 'en',
            label: 'English',
            translationFile: TRANSLATION_EN,
        },
        {
            value: 'tr',
            label: 'Türkçe',
            translationFile: TRANSLATION_TR,
        },
        {
            value: 'pl',
            label: 'Polsku',
            translationFile: TRANSLATION_PL,
        },
        {
            value: 'ro',
            label: 'Romana',
            translationFile: TRANSLATION_RO,
        },
        {
            value: 'pt',
            label: 'Portugues',
            translationFile: TRANSLATION_PT,
        },
    ],
    api: 'https://ett.wave.acc.recognize.dev',
    apiTimeout: 60000,
    msAuth: {
        tenantId: 'common',
        clientId: 'be3a47d3-2dae-4f11-9051-bf9f6b23d378',
        keystoreHash: 'Pz8/Oyw/Pz8ePz9qPwxTUEw/Py4NCg==',
        scopes: ['api://be3a47d3-2dae-4f11-9051-bf9f6b23d378/default'],
        redirectUri: 'https://app.ett.wave.acc.recognize.dev',
    },
    deeplinks: [
        'https://ett.wave.acc.recognize.dev/deeplink/',
        'https://app.ett.wave.acc.recognize.dev/deeplink/',
    ],
    whitelistedDomains: [
        'ett.wave.acc.recognize.dev',
        'app.ett.wave.acc.recognize.dev',
    ],
    privacyPolicyUrl: 'https://ett-wave.nl/documents/privacy-policy.html',
    instructionFilmUrl: '',
    applicationInsights: {
        instrumentationKey: null,
    },
};
